// extracted by mini-css-extract-plugin
export default {"page":"Events_page__7ks1W","container":"Events_container__RUtVC","fadeInUp":"Events_fadeInUp__QWCpR","containerHeader":"Events_containerHeader__NerTK","grid":"Events_grid__kOu1V"};